import { render } from "./weixin.vue?vue&type=template&id=05b0c6ba&scoped=true"
import script from "./weixin.vue?vue&type=script&lang=js"
export * from "./weixin.vue?vue&type=script&lang=js"

import "./weixin.vue?vue&type=style&index=0&id=05b0c6ba&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b0c6ba"]])

export default __exports__